import { Icon, IconProps } from "./Icon";

export function IconSnowflake(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M23.99 11.5h-2.94l1.62-1.62-.7-.71-2.33 2.33H13.2L17.7 7H21V6h-2.3l2.14-2.15-.7-.7L18 5.29V3h-1v3.29l-4.51 4.5V4.36l2.33-2.33-.7-.71-1.63 1.62V0h-1v2.94L9.87 1.32l-.71.71 2.33 2.33v6.43L7 6.3V3H6v2.3L3.88 3.17l-.71.71L5.29 6H3v1h3.29l4.5 4.5H4.32L1.99 9.17l-.71.71L2.9 11.5H-.01v1H2.9l-1.62 1.62.71.71 2.33-2.33h6.47L6.29 17H3v1h2.29l-2.12 2.12.71.71L6 18.7V21h1v-3.3l4.49-4.49v6.47l-2.33 2.33.71.7 1.62-1.62V24h1v-2.91l1.63 1.62.7-.7-2.33-2.33v-6.47l4.51 4.5V21h1v-2.29l2.14 2.14.7-.71L18.7 18H21v-1h-3.3l-4.5-4.5h6.44l2.33 2.33.7-.71-1.62-1.62h2.94v-1z" />
    </Icon>
  );
}
